// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3f3df731","667":"037d6cb8"}[chunkId] + ".chunk.js";
};